<template>
  <div id="settings-list"
       class="flex flex-col h-full pt-2 overflow-visible"
  >
    <side-list :items="items"
               :selected-id="selectedLabel"
               :with-scrollbar="false"
               id-key="label"
    >
      <template #item="{ item, isItemSelected }">
        <settings-list-item :is-selected="isItemSelected"
                            :label="item.label"
                            :url="item.url"
                            :route="item.route"
                            :icon="item.icon"
                            @click.native="selectLabel(item.label)"
        />
      </template>
    </side-list>
  </div>
</template>

<script>
import SettingsListItem from '@/components/settings/SettingsListItem.vue'
import SideList from '@/components/common/SideList.vue'
import { ROUTE_NAMES } from '@/router'

export default {
  name: 'SettingsList',

  components: { SideList, SettingsListItem },

  computed: {
    selectedLabel() {
      const item = this.items.find(item => item.route === this.$route.name)
      return item ? item.label : 'Bots'
    },
    items() {
      return [
        { label: 'Bots', route: ROUTE_NAMES.bots, icon: 'bot-icon' },
        { label: 'Chat Themes', route: ROUTE_NAMES.botTheme, icon: 'theme-icon' },
        { label: 'Knowledge Bases', route: ROUTE_NAMES.knowledgeBases, icon: 'GPT-icon' },
        { label: 'Variables', route: ROUTE_NAMES.variables, icon: 'variables-icon' },
        { label: 'Integrations', route: ROUTE_NAMES.integrations, icon: 'integrations-icon' },
        { label: 'Channels', url: process.env.VUE_APP_AMIO_MESSAGING_APP_URL, icon: 'channels-icon' },
        { label: 'Billing', url: process.env.VUE_APP_STRIPE_BILLING_URL, icon: 'billing-icon' },
        { label: 'Users', url: process.env.VUE_APP_USERS_URL, icon: 'users-icon' }
      ]
    }
  },

  methods: {
    selectLabel(label) {
      this.$emit('label-selected', label)
    }
  }
}
</script>

<style lang="scss">
#settings-list {
  .vb-dragger {
    @apply hidden invisible;
  }

  @apply p-1;

  a {
    @apply text-gray-dark;
  }
}
</style>
